import type { RouteSegment } from '@/api/main/types.gen'
import { REMOVAL_GAP_SEGMENT_ID } from './constants'

/** True when the plan still contains synthetic removal-gap markers that must never reach the API. */
export function hasRemovalGapMarkers(segments: Array<Pick<RouteSegment, 'street_segment_id'>>): boolean {
  return segments.some(s => s.street_segment_id === REMOVAL_GAP_SEGMENT_ID)
}

export type SaveBlockReason = 'activeEdit' | 'gaps' | null

/** An active mid-route edit means the detached tail is missing from `segments`; gaps mean a broken plan. */
export function routePlanSaveBlockReason(options: {
  hasActiveEdit: boolean
  hasBlockingGaps: boolean
}): SaveBlockReason {
  if (options.hasActiveEdit) return 'activeEdit'
  if (options.hasBlockingGaps) return 'gaps'
  return null
}

export function canSubmitRoutePlan(options: {
  hasSaveTarget: boolean
  routeLoadError: boolean
  hasActiveEdit: boolean
  hasBlockingGaps: boolean
}): boolean {
  return options.hasSaveTarget && !options.routeLoadError && routePlanSaveBlockReason(options) === null
}
